import './App.css';
import Topbar from './component/topbar/Topbar';
import Home from './pages/home/Home';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom"
import About from './pages/about/About';
import Contact from './pages/contact/Contact';
import Journal from './pages/journal/Journal';
function App() {
  return (
      <Router>
    <div className="app">
      <Topbar/>
        
     <div className='home'>
       <Routes>
         <Route path="/" element={<Home/>}/>
         <Route path="/about" element={<About/>}/>
         <Route path="/contact" element={<Contact/>}/>
         <Route path="/journal" element={<Journal/>}/>
       </Routes>
     </div>
    </div>
      </Router>
  );
}

export default App;
